import $ from 'jquery';
import { onPageLoad } from '@/js/modules/page_load';

onPageLoad(() => {
  $('.dropdown-menu__link--delete-invoice').on('click', function (e) {
    const { deleteUrl } = $(e.target).data();
    $('#modal--delete-confirmation--invoice').modal();
    $('#modal--delete-confirmation--invoice .d-button--confirm-delete').attr('href', deleteUrl);
    $('#modal--delete-confirmation--invoice .modal__header').text(
      'Are you sure you want to delete this invoice?'
    );
  });

  $('.dropdown-menu__link--delete-invoice-refund').on('click', function (e) {
    const { deleteUrl } = $(e.target).data();
    $('#modal--delete-confirmation--invoice').modal();
    $('#modal--delete-confirmation--invoice .d-button--confirm-delete').attr('href', deleteUrl);
    $('#modal--delete-confirmation--invoice .modal__header').text(
      'Are you sure you want to delete this refund invoice?'
    );
  });

  $(document).on($.modal.CLOSE, '.modal--change-status', () => {
    $('.modal--change-status').remove();
  });

  $(document).on('ajax:success', '.assign-missing-vendors-form', (_, data) => {
    $(data).appendTo('body').modal();
  });
});
